import React, {useEffect} from 'react';

import {
    sendDesktopAnalyticsEvent,
    sendDesktopAnalyticsPerSession,
} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {useInView} from 'react-intersection-observer';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {Price} from 'components/price/price';
import {TYP_MENTION_ME} from 'constants/analytics/events/typ';
import {ORDER_TRACKING} from 'constants/analytics/mentionMe';

import {useMentionMe} from './hooks/useMentionMe';
import mentionMeImg from './img/mention-me.png';
import {PropsMentionType} from './mentionMeTypes';

import s from './mentionMeBanner.scss';

/**
 * Mention me banner at the bottom of rewards banner
 */
export const MentionMeBanner = ({classes = '', integratingType, params}: PropsMentionType) => {
    const {generateScript, shouldHide} = useMentionMe(params, integratingType);
    const {generateScript: generateOrderScript} = useMentionMe(params, ORDER_TRACKING);

    const {inView, ref} = useInView();

    const onCtaClick = () => {
        sendDesktopAnalyticsEvent(TYP_MENTION_ME, {
            label: 'CTA - Clicked',
        });
        generateScript();
    };

    useEffect(() => {
        if (!shouldHide && inView)
            sendDesktopAnalyticsPerSession({
                event: TYP_MENTION_ME,
                isInteraction: true,
                label: 'CTA - Showed',
            });
    }, [shouldHide, inView]);

    useEffect(() => {
        generateOrderScript();
    }, [generateOrderScript]);

    if (shouldHide) return null;

    return (
        <article className={s.wrapper} ref={ref}>
            <CloudinaryImage alt="Extra $25 Off" className={s.bannerImg} src={mentionMeImg} />
            <h3 className={s.title}>
                Invite friends - you’ll both get an extra <Price>25</Price> OFF!
            </h3>
            <p className={s.paragraph}>
                Your friends will get an extra $25 OFF their first order, and you’ll get an extra{' '}
                <Price>25</Price> OFF your next order too.
            </p>
            <button className={s.cta} onClick={onCtaClick} type="button">
                Get Extra <Price>25</Price> OFF
            </button>
            <div className={classes} data-testid="mmWrapper" id="mmWrapper" role="presentation" />
        </article>
    );
};
